/**
 * Idle scheduling utility.
 */

/**
 * Run `fn` when the browser is idle, falling back to a timer where
 * requestIdleCallback is unavailable (Safari). `timeout` bounds the idle wait;
 * `fallbackDelay` is the setTimeout delay used on the fallback path.
 */
export function runWhenIdle(fn, { timeout = 2000, fallbackDelay = 0 } = {}) {
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(fn, { timeout });
  } else {
    setTimeout(fn, fallbackDelay);
  }
}
